<template>
  <div class="cc-acc-content" v-loading="loading">
    <div class="cc-acc-content-drawer">
      <div class="acc-content-drawer-left">
        <el-form label-width="68px" label-position="left">
          <div class="cc-advertiser-form-box">
            <div class="form-box-top">
              <el-form-item label="广告主" label-width="68px">
                  <el-select v-model="filterForm.partnerId" filterable  size="small">
                    <el-option label="不限" value>不限</el-option>
                    <el-option
                      v-for="item in adPartnerIdList"
                      :key="item.partnerId"
                      :label="item.partnerName"
                      :value="item.partnerId"
                    ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="账号名称">
                  <el-input v-model="filterForm.agentAccountName" size="small"  @keyup.enter.native="handleRefresh" clearable></el-input>
              </el-form-item>
              <el-form-item label="状态" size="small" >
                  <el-select v-model="filterForm.disabled">
                    <el-option label="不限" value>不限</el-option>
                    <el-option label="启用" :value="0"></el-option>
                    <el-option label="禁用" :value="1"></el-option>
                  </el-select>
              </el-form-item>
            </div>
            <div class="form-box-center" v-if="isMore">
              <el-form-item label="登录账号" >
                  <el-input v-model="filterForm.agentAccount" size="small"  @keyup.enter.native="handleRefresh" clearable></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                  <el-input v-model="filterForm.phone" size="small"  @keyup.enter.native="handleRefresh" clearable></el-input>
              </el-form-item>
              <el-form-item label="邮件地址">
                  <el-input v-model="filterForm.email" size="small "  @keyup.enter.native="handleRefresh" clearable></el-input>
              </el-form-item>
            </div>
            <div class="form-box-top">
            <!-- <el-form-item label="账号类型" v-if="isMore" >
                <el-select v-model="filterForm.flag">
                  <el-option label="不限" value>不限</el-option> -->
                  <!-- <el-option label="管理员" :value="0"></el-option> -->
                  <!-- <el-option label="操作员" :value="1"></el-option>
                  <el-option label="业务员" :value="2"></el-option>
                  <el-option label="数据员" :value="3"></el-option>
                  <el-option label="财务" :value="4"></el-option>
                </el-select>
            </el-form-item> -->
            </div>
          </div>
        </el-form>
      </div>
      <div class="acc-content-drawer-right">
        <el-button size="small"  type="primary" icon="el-icon-search" @click.stop="handleRefresh">查询</el-button>
        <el-button size="small" @click.stop="resetFilter">重置</el-button>
        <el-button size="small" type="text" class="is-more" @click="clickLoadingMore">
          {{isMore ? '收起' : '展开'}}
          <i :class="isMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </el-button>
      </div>
    </div>
    <div class="cc-acc-content-list">
      <div class="cc-acc-head-but">
        <el-button size="small" type="primary" @click="handleCreate">+ 创建广告主账号</el-button>
        <el-button size="small"  style="float:right" @click="handleDel">删除</el-button>
      </div>
      <Table
        :props="table.props"
        :header="table.header"
        :data="table.data"
        :selected="table.selected"
        :selection-type="table.selectionType"
        @row-selection-add="handleRowSelectionAdd"
        @row-selection-remove="handleRowSelectionRemove"
        @all-row-selection-change="handleAllRowSelectionChange"
      />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { Table } from '@ccprivate/admin-toolkit'
// eslint-disable-next-line no-unused-vars
export default {
  components: {
    Table
  },
  data() {
    return {
      loading: false,
      filterForm: {
        agentAccount: '',
        agentAccountName: '',
        partnerId: '',
        phone: '',
        email: '',
        flag: '',
        disabled: ''
      },
      table: {
        props: {
          border: true,
          stripe: false,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: 'ID',
            prop: 'agentAccountId',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 40
          },
          {
            label: '登录账号',
            prop: 'agentAccount',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 100,
            render: (h, { row }) => {
              return row.agentAccount ? this.$decrypt(row.agentAccount) : ''
            }
          },
          {
            label: '账号名称',
            prop: 'agentAccountName',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 100
          },
          {
            label: '广告主',
            prop: 'partnerId',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 100,
            render: (createElement, { row }) => {
              for (let i = 0; i < this.adPartnerIdList.length; i++) {
                if (row.partnerId === this.adPartnerIdList[i].partnerId) {
                  return this.adPartnerIdList[i].partnerName
                }
              }
            }
          },
          {
            label: '手机号',
            prop: 'phone',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 100
          },
          {
            label: '邮件地址',
            prop: 'email',
            'show-overflow-tooltip': true,
            align: 'left',
            'min-width': 100
          },
          {
            label: '账号类型',
            prop: 'flag',
            align: 'left',
            'min-width': 100,
            'show-overflow-tooltip': true,
            render: (createElement, { row }) => {
              const arr = ['管理员', '操作员', '业务员', '数据员', '财务']
              return arr[row.flag]
            }
          },
          {
            label: '状态',
            prop: 'disabled',
            align: 'left',
            'min-width': 100,
            'show-overflow-tooltip': true,
            render: (createElement, { row }) => {
              const arr = ['启用', '禁用']
              return arr[row.disabled]
            }
          },
          {
            label: '操作',
            align: 'left',
            'min-width': 150,
            fixed: 'right',
            isShow: true,
            render: (h, { row }) => {
              return h('div', [
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: event => {
                        event.stopPropagation()
                        this.handleRead(row)
                      }
                    }
                  },
                  '详情'
                ),
                h(
                  'el-button',
                  {
                    props: {
                      type: 'text'
                    },
                    class: 'el-table-button-text',
                    on: {
                      click: event => {
                        event.stopPropagation()
                        this.handleEdit(row)
                      }
                    }
                  },
                  '编辑'
                )
                // h(
                //   'el-button',
                //   {
                //     props: {
                //       type: 'text'
                //     },
                //     class: 'el-table-button-text',
                //     on: {
                //       click: event => {
                //         event.stopPropagation()
                //         this.handleDisabled(row)
                //       }
                //     }
                //   },
                //   row.disabled === 0 ? '禁用' : '启用'
                // )
              ])
            }
          }
        ],
        data: [],
        selected: [],
        selectionType: 'multiple'
      },
      pageSize: 10,
      currentPage: 1,
      totalCount: 1,
      selected: [],
      selectedRow: [],
      adPartnerIdList: [],
      isMore: false
    }
  },
  methods: {
    getAccAdAgentAccountDataList() {
      this.loading = true
      this.$service
        .getAccAdAgentAccountDataList({})
        .then(data => {
          this.adPartnerIdList = data
          this.fetchData()
        })
        .catch(() => {
          this.loading = false
        })
    },
    fetchData() {
      let filterForm = this.filterForm
      filterForm.pageNo = this.currentPage
      filterForm.pageSize = this.pageSize
      this.table.data = []
      this.drawerDialog = false
      this.loading = true
      this.$service.getAccAdDspCustomerPageList(filterForm).then(data => {
        this.totalCount = data.total || 0
        this.table.data = data.rows || []
        this.handleAllRowSelectionRemove()
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleCreate() {
      this.$emit('create')
    },
    handleDel() {
      if (this.selected.length === 0) {
        this.$message.error('请选择一条数据')
      } else {
        this.$confirm('是否确定要进行删除操作？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        })
          .then(() => {
            this.loading = true
            this.$service.getAccAdDspCustomerDelete(this.selected).then(data => {
              if (
                this.table.data.length === this.selected.length &&
              this.currentPage > 1
              ) {
                this.currentPage--
              }
              this.fetchData()
              this.loading = false
            })
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    resetFilter() {
      this.filterForm = {
        agentAccount: '',
        agentAccountName: '',
        partnerId: '',
        phone: '',
        email: '',
        flag: '',
        disabled: ''
      }
      this.handleRefresh()
    },
    clickLoadingMore() {
      this.isMore = !this.isMore
    },
    handleFilter() {
      this.drawerDialog = true
    },
    handleRead(row) {
      this.$emit('read', row)
    },
    handleDisabled(row) {
      let text = row.disabled === 0 ? '禁用' : '启用'
      this.$confirm('是否要进行' + text + '操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          if (row.disabled === 0) {
            row.disabled = 1
          } else {
            row.disabled = 0
          }
          this.$service
            .accAdDspCustomerEdit(row)
            .then(data => {
              this.loading = false
              this.$message(data.message)
            })
            .catch(() => {
              this.loading = false
            })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$emit('edit', row)
    },
    // 表格操作
    handleRefresh() {
      this.currentPage = 1
      this.fetchData()
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleRowSelectionAdd(targetItem) {
      this.selected.push(targetItem.agentAccountId)
      this.selectedRow.push(targetItem)
      this.updateTableSelected()
    },
    handleRowSelectionRemove(targetItem) {
      this.selected = this.selected.filter(item => {
        return item !== targetItem.agentAccountId
      })
      this.selectedRow = this.selectedRow.filter(item => {
        return item.agentAccountId !== targetItem.agentAccountId
      })
      this.updateTableSelected()
    },
    updateTableSelected() {
      const table = this.table
      const newSelectedIndex = this.selected
      this.selectedRow = []
      table.selected = table.data.reduce((result, item, index) => {
        if (newSelectedIndex.indexOf(item.agentAccountId) > -1) {
          this.selectedRow.push(item)
          result.push(index)
        }
        return result
      }, [])
    },
    handleAllRowSelectionChange(value) {
      if (value) {
        this.table.data.forEach(this.handleRowSelectionAdd)
      } else {
        this.selected = []
        this.selectedRow = []
        this.table.selected = []
      }
    },
    handleAllRowSelectionRemove() {
      this.selected = []
      this.selectedRow = []
      this.table.selected = []
    }
  },
  created() {
    this.getAccAdAgentAccountDataList()
  }
}
</script>
<style lang="stylus" scoped>
.el-drawer__wrapper .el-drawer__header span:focus {
  outline: 0px;
}

.el-drawer__wrapper .el-drawer.ttb {
  height: auto !important;
}
</style>
<style lang="stylus" scoped>
.cc-acc-content {
  padding: 16px;
}

.cc-acc-content .cc-acc-head-but {
  overflow: hidden;
  margin-bottom 16px
}

.cc-acc-content-list {
  background: #FFF;
  padding 16px 24px
  // padding: 10px;
}

.cc-acc-content-drawer {
  background: #FFF;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 16px 16px 16px 24px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
}

.cc-acc-content-drawer .el-form-item {
  margin-bottom: 0px;
}

.cc-acc-content-drawer .is-more {
  font-size: 14px;
}

.acc-content-drawer-left {
  width: calc(100% - 208px);
}

.acc-content-drawer-right {
  width: 199px;
  margin-right: 8px;
}

>>>.el-tabs__header {
  margin: 0;
}

.cc-advertiser-form-box {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.form-box-top,.form-box-center {
  display: flex;
  width 100%
}
.form-box-top>div,.form-box-center>div {
  margin-right 16px
  width 30%
}
.form-box-center {
  margin 16px 0
}
>>>.el-select {
    display flex
  }
>>>.el-table-button-text {
  color: #1890FF;
}
</style>
